import type { ThemeConfig } from 'antd';

import { APP_FONT_FAMILY } from '.';

const antdTheme: ThemeConfig = {
  token: { fontFamily: APP_FONT_FAMILY },
  components: {
    // headerMarginBottom is honoured at runtime but omitted from Modal's public ComponentToken
    Modal: { headerMarginBottom: 16 } as NonNullable<ThemeConfig['components']>['Modal'],
  },
};

export default antdTheme;
